import { Colors } from '~/themes/colors';

interface IWarningFullOutlineIconProps {
  color?: string;
  size?: number;
}

export const WarningFullOutlineIcon = ({
  color = Colors.neutral_400,
  size = 24,
}: IWarningFullOutlineIconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M14.6363 3.5334C13.8079 2.07771 11.9561 1.56899 10.5 2.39738C10.026 2.6672 9.63333 3.05948 9.36393 3.5334L1.37994 17.7574C0.863919 18.6661 0.874231 19.7815 1.40658 20.6804C1.9471 21.608 2.94263 22.1752 4.01635 22.1661H19.9839C21.0572 22.1747 22.0531 21.608 22.5937 20.6804C23.126 19.7811 23.1363 18.6657 22.6203 17.7574L14.6363 3.5334ZM21.0112 19.7575C20.7964 20.1192 20.4045 20.3388 19.9839 20.3332H4.01635C3.59485 20.3384 3.203 20.1179 2.98903 19.7549C2.7858 19.4172 2.78193 18.9961 2.97915 18.6549L10.9623 4.43011C11.3391 3.85694 12.1095 3.69796 12.6826 4.07521C12.824 4.16801 12.9447 4.28875 13.0375 4.43011L21.0211 18.6541C21.2183 18.9957 21.2144 19.4172 21.0112 19.7549V19.7575Z"
      fill={color}
      stroke={color}
      strokeWidth="0.3"
    />
    <path
      d="M12.0001 7.5C11.4939 7.5 11.0836 7.91033 11.0836 8.41647L11.0836 14.5001C11.0836 15.0062 11.494 15.4165 12.0001 15.4165C12.5063 15.4165 12.9166 15.0062 12.9166 14.5001L12.9165 8.41647C12.9165 7.91033 12.5062 7.5 12.0001 7.5Z"
      fill={color}
      stroke={color}
      strokeWidth="0.3"
    />
    <path
      d="M12.0001 18.4998C12.5062 18.4998 12.9166 18.0895 12.9166 17.5833C12.9166 17.0772 12.5062 16.6669 12.0001 16.6669C11.4939 16.6669 11.0836 17.0772 11.0836 17.5833C11.0836 18.0895 11.4939 18.4998 12.0001 18.4998Z"
      fill={color}
      stroke={color}
      strokeWidth="0.3"
    />
  </svg>
);
